import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppliancesAspirator = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "appliances-aspirator" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M6.92,17.857,6.3,18.68a1.585,1.585,0,0,0,.243,2.177h0a1.585,1.585,0,0,1,.242,2.177l-.162.216"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M12.557,17.857l-.618.823a1.584,1.584,0,0,0,.243,2.177h0a1.585,1.585,0,0,1,.242,2.177l-.162.216"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M17.807,17.857l-.618.823a1.584,1.584,0,0,0,.243,2.177h0a1.585,1.585,0,0,1,.242,2.177l-.162.216"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M17.25,3.75H6.75L1.111,8.25a1.5,1.5,0,0,0-.361.976V12.75a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5V9.226a1.5,1.5,0,0,0-.361-.976Z"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "6.75 0.75 6.75 3.75 17.25 3.75 17.25 0.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.25,
			y1: 11.25,
			x2: 7.5,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 10.5,
			y1: 11.25,
			x2: 12.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.75,10.875a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 1.111,
			y1: 8.25,
			x2: 22.889,
			y2: 8.25
		})
	]
});
export default SvgAppliancesAspirator;
